export default __webpack_public_path__ + "static/blob10-9f679f00b7dd7e80ec4eb855f0bcaad4.svg";